import React from 'react';
import './SectionHeader.css';

interface SectionHeaderProps {
  title: string;
  description: string;
  rightContent?: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  title, 
  description, 
  rightContent,
  className = ''
}) => {
  return (
    <div className={`charts-header ${className}`}>
      <div className="charts-header-content">
        <div className="charts-title-section">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        {rightContent && rightContent}
      </div>
    </div>
  );
};

export default SectionHeader;

